import Vue from 'vue'
import axios from 'axios'

const SET_PLOTS = 'SET_PLOTS'
const SET_REPORT_GENERATOR = 'SET_REPORT_GENERATOR'

import {
  SERVICE_LINKS,
} from '@/store/ServiceRegistry/linkedservices'

function initialState() {
  return {
    plots: {
      data: [],
      isLoading: false,
      totalCount: 0,
      reportGenerator: null,
    },
  }
}

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async getPlots({
      commit,
      state,
    }, options) {
      if (options.forced != true && state.plots.data.length > 0) {
        return
      }
      try {
        state.plots.isLoading = true
        let res = await axios.get('api/vegetativemonitoring/plots')

        commit(SET_PLOTS, res.data)
      } catch (error) {
        throw error
      } finally {
        state.plots.isLoading = false
      }
    },
    async fetchReportGenerator({
      commit,
      state,
      dispatch,
    }) {
      if (state.reportGenerator == null) {
        try {
          let reportGenerator = await dispatch('linkedservices/getServiceByLink', {
            serviceLink: SERVICE_LINKS.VEGETATIVE_MONITORING_QUERY_REPORT,
          }, {
            root: true,
          })
          commit(SET_REPORT_GENERATOR, reportGenerator)
        } catch (e) {
          console.error(e)
          throw e
        }
      }
    },
  },
  mutations: {
    [SET_PLOTS](state, data) {
      Vue.set(state.plots, 'data', data.Plots.sort((a, b) => a.PlotName > b.PlotName))
      Vue.set(state.plots, 'totalCount', data.Count)
    },
    [SET_REPORT_GENERATOR](state, data) {
      state.reportGenerator = data
    },
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
  getters: {},
}

export {}